import { Component, Input, OnInit } from '@angular/core';
import { UserModel } from '../users/users.service';
import { InvoiceHistoryTableService } from './invoice-history-table.service';
import { get } from 'http';
import { InvoicedetailService } from '../invoicedetail/invoicedetail.service';
import { Router } from '@angular/router';

@Component({
  selector: 'app-InvoiceHistoryTable',
  templateUrl: './InvoiceHistoryTable.component.html',
  styleUrls: ['./InvoiceHistoryTable.component.scss'],
})
export class InvoiceHistoryTableComponent implements OnInit {

  @Input() UserData!: UserModel;

  Loading: boolean = false;

  ngOnInit(): void {
    this.getInvoices();
  }

  constructor(
    public InvoiceHistoryTableService: InvoiceHistoryTableService,
    public InvoicedetailService: InvoicedetailService,
    public router: Router,
  ) {
    
  }

  PaymentHistoryData: any = [

  ];

  //dummy data for testing PaymentHistoryData
  DPaymentHistoryData: any = [
    {
      docRefNo: '123',
      invoiceDate: '12/12/2021',
      invoiceDueDate: '12/12/2021',
      totalAmount: '1000',
      isPaid: 'Paid',
      paymentDate: '12/12/2021',
    },
    {
      docRefNo: '123',
      invoiceDate: '12/12/2021',
      invoiceDueDate: '12/12/2021',
      totalAmount: '1000',
      isPaid: 'Paid',
      paymentDate: '12/12/2021',
    },
    {
      docRefNo: '123',
      invoiceDate: '12/12/2021',
      invoiceDueDate: '12/12/2021',
      totalAmount: '1000',
      isPaid: 'Paid',
      paymentDate: '12/12/2021',
    },
    {
      docRefNo: '123',
      invoiceDate: '12/12/2021',
      invoiceDueDate: '12/12/2021',
      totalAmount: '1000',
      isPaid: 'Paid',
      paymentDate: '12/12/2021',
    },
    {
      docRefNo: '123',
      invoiceDate: '12/12/2021',
      invoiceDueDate: '12/12/2021',
      totalAmount: '1000',
      isPaid: 'Paid',
      paymentDate: '12/12/2021',
    },
    {
      docRefNo: '123',
      invoiceDate: '12/12/2021',
      invoiceDueDate: '12/12/2021',
      totalAmount: '1000',
      isPaid: 'Paid',
      paymentDate: '12/12/2021',
    },
  ];


  PaymentHistoryColumns: any = [
    {
      key: 'docRefNo',
      label: 'Invoice No.',
    },
    {
      key: 'productName',
      label: 'Product Name',
    },

    {
      key: 'invoiceDate',
      label: 'Date',
    },
    {
      key: 'invoiceDueDate',
      label: 'Due Date',
    },
    {
      key: 'Amount',
      label: 'Amount',
      _style: { width: '120px' },
    },
    {
      key: 'isPaid',
      label: 'Status',
      _style: { width: '120px' },

    },
    {
      key: 'paymentDate',
      label: 'Payment Date',
    },
    // {
    //   key: 'Actions',
    //   label: '',
    //   _style: { width: '5%' },
    //   filter: false,
    //   sorter: false,
    // },
  ];

  getInvoices() {
    this.Loading = true;
    if(this.UserData.userType_Id == 6 ){
      var body = {
        id: this.UserData.id,
        userType: 'C'
      }; 
    } else {
      var body = {
        id: this.UserData.id,
        userType: 'P'
      };

      
    }
    console.log("🚀 > getInvoices > body:", body)
    this.InvoiceHistoryTableService.getByPartnerORClient(body).subscribe({
      next: (res: any) => {

        console.log("🚀 > InvoiceHistoryTableComponent > this.InvoiceHistoryTableService.getByPartnerORClient > res:", res)
        this.PaymentHistoryData = res.data;

        this.Loading = false;
      },


      error: (error) => {
        console.error(error);
        this.Loading = false;
      },
    });

  }

  OpenInvoicePage(data: any) {
    console.log("🚀 > InvoiceHistoryTableComponent > OpenInvoicePage > data:", data)
    this.InvoicedetailService.selectedInvoiceDataUpdate(data);
    this.router.navigate(['/invoicedetail']);

    
  }


}
